<template>
  <div class="inner">
    <p id="detailHd">NEWS</p>
    <ul id="pankuzu" class="flex flex-left">
      <li><a href="/" class="opacity">ホーム</a></li>
      <li><a href="/news" class="opacity">ニュース一覧</a></li>
      <li>{{ title }}</li>
    </ul>
    <article id="detailInner">
      <header id="newsHd">
        <p class="newsItem-date">{{ date }}</p>
        <h1 id="newsHd-ttl">{{ title }}</h1>
      </header>
      <div id="editor" v-html="compiledMarkdownText" />
    </article>
  </div>
</template>

<script>
import marked from 'marked'
import {News} from '../assets/js/news.js'
const news = new News()
export default {
  name: 'NewsDetail',
  data () {
    return {
      title: '',
      date: '',
      newsDetail: [],
      md: ''
    }
  },
  computed: {
    compiledMarkdownText: function () {
      return marked(this.md)
    }
  },
  methods: {
  },
  beforeRouteEnter: function (to, from, next) {
    const newsDetail = news.list.find((news) => news.path === to.params.path)
    if (newsDetail && newsDetail.is_show) {
      next(vm => {
        vm.newsDetail = newsDetail
      })
    } else {
      next({name: 'NotFound'})
    }
  },
  created: function () {
    const renderer = new marked.Renderer()

    // aタグ
    renderer.link = function (href, title, text) {
      return '<a href="' + href + '" rel="noopener noreferrer" target="_blank">' + text + '</a>'
    }

    marked.setOptions({
      renderer: renderer
    });

    import('../assets/news/' + this.$route.params.path + '.md')
      .then((module) => {
        this.md = module.default.source.replace(/&lt;br&gt;/g, '<br>')
      });
  },
  watch: {
    'newsDetail': function () {
      document.title = this.newsDetail.title + this.$route.meta.title
      document.querySelector("meta[name='description']").setAttribute('content', this.newsDetail.title)
      this.title = this.newsDetail.title
      this.date = this.newsDetail.formatDate
    }
  }
}
</script>

<style scoped>
  #newsHd{
    width:100%;
    padding-top:40px;
    margin-bottom:40px;
  }

  #newsHd-ttl{
    font-size:234%;
    font-weight:bold;
    line-height:1.75;
    margin-top:26px;
  }

  #newsHd-ttl::after{
    display:block;
    content:"";
    width:216px;
    height:1px;
    margin-top:26px;
    background:#000;
  }

  #editor{
    font-size:134%;
    line-height:2;
  }

  /deep/ #editor *{ line-height:inherit;}
  /deep/ #editor a{ color:#F3D22D;}
  /deep/ #editor > p{ margin-top:20px;}

  /deep/ #editor table{
    width: 100%;
    margin: 10px 0 30px;
  }

  /deep/ #editor th{
    border-top: 1px solid #333;
    border-right: 1px solid #333;
    padding: 10px;
  }

  /deep/ #editor tr{
    border-left: 1px solid #333;
    border-bottom: 1px solid #333;
  }

  /deep/ #editor td{
    border-top: 1px solid #333;
    border-right: 1px solid #333;
    padding: 10px;
  }

  /deep/ #editor ul {
    padding-left : 1.5em;
  }

  /deep/ #editor ul li {
    position: relative;
    list-style-type: disc;
  }

  /deep/ ul#editor li ul {
    padding-left : 1.5em;
  }

  /*------------------------------------------------------------
      MediaQuery
  ------------------------------------------------------------*/

  /* PC */
  @media screen and (max-width: 1180px) and (min-width: 835px){
    #newsHd{
      padding-top:3.389830508474576vw;
      margin-bottom:3.389830508474576vw;
    }

    #newsHd-ttl{
      font-size:2.372881355932203vw;
      margin-top:2.203389830508475vw;
    }

    #newsHd-ttl::after{
      width:18.30508474576271vw;
      margin-top:2.203389830508475vw;
    }

    #editor{ font-size:1.355932203389831vw;}
    #editor > p{ margin-top:1.694915254237288vw;}
  }

  /* TABLET */
  @media screen and (max-width: 834px){
    #newsHd{
      padding-top:20px;
      margin-bottom:30px;
    }

    #newsHd-ttl{
      font-size:175%;
      margin-top:20px;
    }

    #newsHd-ttl::after{
      width:162px;
      margin-top:20px;
    }

    #editor{ font-size:117%;}

  }

  /* SP */
  @media screen and (max-width: 480px){
    #newsHd{
      padding-top:10px;
      margin-bottom:24px;
    }

    #newsHd-ttl{
      font-size:150%;
      margin-top:16px;
    }

    #newsHd-ttl::after{
      width:120px;
      margin-top:16px;
    }

    #editor{ font-size:109%;}
  }
</style>
